var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-view-container"
  }, _vm._l((Array.from(_vm.visitedViews)), function(tag) {
    return _c('router-link', {
      key: tag.path,
      staticClass: "tabs-view",
      attrs: {
        "to": tag.path
      }
    }, [_c('el-tag', {
      attrs: {
        "closable": true,
        "type": _vm.isActive(tag.path) ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          _vm.closeViewTabs(tag, $event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")])], 1)
  }))
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57015451", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57015451","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/TabsView.vue
// module id = BupL
// module chunks = 212